<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.5938 8.86566C22.5146 9.16196 23.1562 10.0408 23.1562 11.0502V15.5144C23.1562 16.6984 22.2735 17.7024 21.0935 17.7987C20.7404 17.8275 20.3863 17.8527 20.0312 17.8742V21.0938L16.9062 17.9688C15.4961 17.9687 14.0996 17.9113 12.719 17.7986C12.4082 17.7732 12.1181 17.6849 11.8593 17.5469M21.5938 8.86566C21.436 8.81491 21.2701 8.78126 21.0978 8.76696C19.7158 8.65225 18.3178 8.59375 16.9062 8.59375C15.4946 8.59375 14.0967 8.65225 12.7147 8.76695C11.5365 8.86474 10.6562 9.86795 10.6562 11.0502V15.5143C10.6562 16.3865 11.1353 17.161 11.8593 17.5469M21.5938 8.86566V6.91386C21.5938 5.22489 20.394 3.76109 18.7191 3.54366C16.5915 3.26746 14.4219 3.125 12.219 3.125C10.016 3.125 7.84617 3.26748 5.71837 3.54374C4.04347 3.76119 2.84375 5.22498 2.84375 6.91394V13.3986C2.84375 15.0875 4.04347 16.5513 5.71838 16.7688C6.31938 16.8468 6.92374 16.9142 7.53125 16.9707V21.875L11.8593 17.5469"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMessages',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
